import { Action, createReducer, on } from "@ngrx/store";
import { CashbookViewColumn1ViewModelActions } from "../actions";
import {
  initialState,
  Column1ViewModelState,
} from "../states/column_1_view_model.states";
export const CashbookViewColumn1ViewModelReducer = createReducer(
  initialState,
  on(CashbookViewColumn1ViewModelActions.setGenericDocCashbookListing_State, (state, action) => ({
    ...state, genericDocCashbookListingState: action.genericDocCashbookListingState
  })),
);
export function reducer(
  state: Column1ViewModelState | undefined,
  action: Action
) {
  return CashbookViewColumn1ViewModelReducer(state, action);
}